import React from 'react';

const LoadingLayer = ({ visible, hideAll = false }) => {
	return (
		visible && (
			<div className={`overlay white upper ${hideAll ? 'full' : ''}`}>
				<div className="mdst-spinner">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		)
	);
};

export default LoadingLayer;
